import { Card } from "@components/cards/card";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { FiAlertTriangle } from "react-icons/fi";
import { ModalRafflePayment } from "@components/modals/modal-raffle-payment";
import { useState } from "react";

interface IProps {
  raffleId: string | null;
  onPaid: (paid: boolean, timeToClose: number) => void;
}

export function RaffleDefaultCardCreatePayment({ raffleId, onPaid }: IProps) {
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [showPayment, setShowPayment] = useState<boolean>(false);

  return (
    <>
      <Card>
        {/* Alert Header */}
        <span className="end-0 bg-warning text-white p-2 rounded-top text-center d-block">
          <FiAlertTriangle className="me-2" />
          <span className="text-uppercase">Mensagem Importante</span>
        </span>

        {/* Header */}
        <div className="card-header text-center">
          <h5 className="fw-bold mb-0">Pagamento da Campanha</h5>
        </div>

        {/* Body */}
        <div className="card-body">
          <div className="text-center mb-4">
            <div className="h5 fw-bold">
              Campanha com pendência de pagamento.
            </div>
            <div className="text-muted">
              Efetue o pagamento para que a Campanha inicie.
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => setShowPayment(true)}
            >
              Ver Pagamento
            </button>
          </div>
        </div>
      </Card>

      <ModalRafflePayment
        raffleId={raffleId || ""}
        isOpen={showPayment}
        onClose={() => setShowPayment(false)}
        onPaid={(paid, timeToClose) => {
          onPaid(paid, timeToClose);
        }}
      />
    </>
  );
}
